import { ThemeProvider } from '@theme'
import { QueryProvider } from './QueryProvider'
import { AuthProvider }  from './AuthProvider'

/**
 * AppProviders composes all global providers in one place.
 * Order matters:
 *   1. ThemeProvider  — outermost so every provider and component can call useTheme()
 *   2. QueryProvider  — must wrap everything that uses useQuery
 *   3. AuthProvider   — uses queryClient internally via authService
 *
 * Add new providers here; never nest them in App.jsx.
 */
export function AppProviders({ children }) {
  return (
    <ThemeProvider>
      <QueryProvider>
        <AuthProvider>
          {children}
        </AuthProvider>
      </QueryProvider>
    </ThemeProvider>
  )
}
